/* eslint-disable import/no-unused-modules */
import React from 'react';
import styled from 'styled-components';

import { Skeleton } from '@/ui/Skeleton';
import { makeNamespacedComponent } from '@/ui/utils';

const Title = styled.div`
  ${(p) => p.theme.typography.title3};
  color: ${({ theme }) => theme.colors.neutral.onBackground};
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const TitleSkeleton = styled(Skeleton)`
  margin: 0px 0 24px 0;
`;

const Body = styled.div`
  ${(p) => p.theme.typography.body1};
  color: ${({ theme }) => theme.colors.neutral.onBackground};
`;

type StartDescriptionProps = {
  headline?: string;
  description?: string;
};

const StartDescription = ({ headline, description }: StartDescriptionProps): JSX.Element => {
  return (
    <Wrapper>
      <Title>{headline}</Title>
      {description && <Body dangerouslySetInnerHTML={{ __html: description || '' }} />}
    </Wrapper>
  );
};

const LoadingState = () => (
  <>
    <TitleSkeleton height={24} width={186} />
    <Skeleton height={24} />
    <Skeleton height={24} />
    <Skeleton height={24} />
  </>
);

const _StartDescription = makeNamespacedComponent(StartDescription, {
  LoadingState,
});

export { _StartDescription as StartDescription };
